import { useStore } from '@nanostores/react';
import { accountStore } from '@/services/auth/store';
import { VerificationState } from '@/services/auth/types';

/**
 * Whether the account has passed the anti-abuse verification review —
 * `verification_state === approved`, the same predicate the delivery-mode
 * gate and banner read. Single swap point: step 1's completion, the
 * `/onboarding` bounce, and the go-live gate all consume this, so a change
 * to the driving signal happens here and callers stay untouched.
 */
export function useIsAccountVerified(): boolean {
  const account = useStore(accountStore);
  return account?.verification_state === VerificationState.Approved;
}
